import ResetPasswordForm from 'components/login/ResetPassword';

function ResetPasswordPage() {
  return (
    <section>
      <ResetPasswordForm />
    </section>
  );
}

export default ResetPasswordPage;
